<template>
  <page-header title="Перевозка труб"/>
  <div class="public-container public-container-mobile shipping-types">
    <div id="about" class="shipping-types-banner-wrapper">
      <div class="shipping-types-banner mb-30">
        <public-card-info img-url="/images/pages/shipping-type/pipes.png">
          <div class="shipping-types-card-text">
            {{ content.blocks?.about.cardText }}
          </div>
        </public-card-info>
      </div>

      <div>
        <h2 class="vz-text-align-left">
          {{ content.blocks?.about.title }}
        </h2>
        <p>{{ content.blocks?.about.description }}</p>
        <ul class="public-list public-list-square">
          <li v-for="text in content.blocks?.about.list.split(';')">
            <span>{{ text }}</span>
          </li>
        </ul>
      </div>
    </div>

    <div id="price" class="shipping-types-block mb-80">
      <h2 class="vz-text-align-left">
        {{ content.blocks?.price.title }}
      </h2>
      <p v-html="content.blocks?.price.description" />
      <div class="public-text-line mt-35" v-html="content.blocks?.price.attention" />
    </div>

    <shipping-types-buttons />

    <div class="metal-grid mb-90">
      <public-info-grid-block v-for="(item, index) of items" :key="index" :item="item" rounded-style/>
    </div>

    <shipping-types-chain current="pipes" />
  </div>
</template>

<script setup lang="ts">
import PageHeader from '~/components/public/page-header.vue'
import PublicCardInfo from '~/components/public/public-card-info.vue'
import {PublicInfoGridItem} from '~/types/public';
import PublicInfoGridBlock from '~/components/public/public-info-grid-block.vue'
import ShippingTypesButtons from '~/components/public/shipping-types/shipping-types-buttons.vue'
import ShippingTypesChain from '~/components/public/shipping-types/shipping-types-chain.vue'
import {getPageContent} from '~/api/content';

const content = await getPageContent('/shippingtypes/pipes')

const items = computed((): PublicInfoGridItem[] => [
  {
    icon: {
      url: '/svg/package.svg'
    },
    title: content.blocks?.order.wrappingTitle,
    text: content.blocks?.order.wrappingText,
  },
  {
    icon: {
      name: 'shield'
    },
    title: content.blocks?.order.insuranceTitle,
    text: content.blocks?.order.insuranceText,
  },
  {
    icon: {
      url: '/svg/icon/vz-home.svg'
    },
    title: content.blocks?.order.addressDeliveryTitle,
    text: content.blocks?.order.addressDeliveryText,
  },
  {
    icon: {
      url: '/svg/box-transportation.svg'
    },
    title: content.blocks?.order.pprTitle,
    text: content.blocks?.order.pprText,
  },
])
</script>

<style lang="scss" scoped>
.metal-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;

  @media screen and (min-width: $pub-md + 1) {
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    div {
      &:nth-child(1) {
        grid-area: 1 / 1 / 2 / 2;
      }

      &:nth-child(2) {
        grid-area: 1 / 2 / 2 / 3;
      }

      &:nth-child(3) {
        grid-area: 1 / 3 / 2 / 4;
      }

      &:nth-child(4) {
        grid-area: 2 / 1 / 3 / 4;
      }
    }
  }

  @media screen and ($pub-md >= width > $pub-sm) {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    div {
      &:nth-child(1) {
        grid-area: 1 / 1 / 2 / 2;
      }

      &:nth-child(2) {
        grid-area: 1 / 2 / 2 / 3;
      }

      &:nth-child(3) {
        grid-area: 2 / 1 / 3 / 3;
      }

      &:nth-child(4) {
        grid-area: 3 / 1 / 4 / 3;
      }
    }
  }
}
</style>
